import React from 'react';
import styled from 'styled-components';
import Clock from '../images/Clocks.png';

// comps
import Edges from './Edges';
import AlertMessage from './shared/AlertMessage';

const Hero = () => {
    return (
        <Container>
            <Edges
                size="md"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}
            >
                <WelcomeText>
                    <Title>BCIT Timetables</Title>
                    <p>Gain access to your program and instructor&apos;s schedules, as well as booking office hours.</p>
                </WelcomeText>
                <img src={Clock} />
            </Edges>
        </Container>
    );
};

const Container = styled.div`
    height: 180px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3em;

    img {
        width: 32vw;
        min-width: 350px;
        margin: 0;
        padding: 0;
    }
    @media (min-width: 640px) {
        height: 260px;
    }
    @media (max-width: 640px) {
        img {
            display: none;
        }
    }
`;
const WelcomeText = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
        font-size: 16px;
    }
`;
const Title = styled.h1`
    color: #005fa5;
    margin-bottom: 0;
    font-weight: 900;
    font-size: 36px;
    @media (min-width: 640px) {
        font-size: 48px;
    }
`;

export default Hero;
